// 常用的方法
import dayjs from 'dayjs';

/**
 * 格式化时间为 YYYY-MM-DD HH:mm:ss
 * @param {Date|string|number} time - 可接受 Date 对象、时间戳或 ISO 字符串
 * @returns {string} 格式化后的时间字符串
 */
export const  formatTime = (time)=> {
  return dayjs(time).format('YYYY-MM-DD');
}

// 渲染树结构
export const buildHierarchy = (data) => {
    const hierarchy = [];  // 存储最终的层级结构
    const map = new Map(); // 存储每个项，便于根据 id 查找
    const seen = new Set(); // 用来存储已处理的 id 和 code，避免重复

    // 先过滤掉重复的 id 和 code 组合，确保每个节点唯一
    const filteredData = data.filter(item => {
        const uniqueKey = `${item.id}-${item.code}`;
        if (seen.has(uniqueKey)) {
            return false;  // 如果已经存在该组合，过滤掉该项
        } else {
            seen.add(uniqueKey);
            return true;  // 如果是唯一的，保留该项
        }
    });

    // 将过滤后的数据存储到 map 中，并初始化 children 为数组
    filteredData.forEach(item => {
        map.set(item.id, { ...item, children: [] });
    });

    // 遍历数据，根据 parentId 构建层级关系
    filteredData.forEach(item => {
        // 如果是顶层元素（parentId 为 -1），则直接加入到层级结构中
        if (item.parentId === "-1") {
            hierarchy.push(map.get(item.id));
        } else {
            // 找到父元素并将当前元素加入父元素的 children 数组
            const parent = map.get(item.parentId);
            if (parent) {
                parent.children.push(map.get(item.id));
            }
        }
    });

    return hierarchy;
}

// 公共的审核状态
export const  formatState = (state)=> {
    switch (state) {
      case 1: return { text: '审批通过', type: 'success' };
      case 2: return { text: '审批驳回', type: 'danger' };
      case 3: return { text: '已取消', type: 'info' };
      case 10: return { text: '待一级审批', type: 'warning' };
      case 11: return { text: '一级审批通过', type: 'warning' };
      case 12: return { text: '一级审批驳回', type: 'warning' };
      case 20: return { text: '待二级审批', type: 'primary' };
      case 21: return { text: '二级审批通过', type: 'primary' };
      case 22: return { text: '二级审批驳回', type: 'primary' };
      case 30: return { text: '待三级审批', type: 'primary' };
      case 31: return { text: '三级审批通过', type: 'primary' };
      case 32: return { text: '三级审批驳回', type: 'primary' };
      default: return { text: '未知状态', type: 'default' };
    }
  }



/**
 * 将 Blob 数据流转换为文件并触发浏览器下载
 * @param {Blob} data - blob 数据
 * @param {string} filename - 文件名（含扩展名）
 * @param {string} mimeType - 文件类型，默认 application/vnd.ms-excel
 */
export function downloadFile(data, filename = "文件.xlsx", mimeType = "application/vnd.ms-excel") {
  const blob = new Blob([data], { type: mimeType });
  const downloadUrl = window.URL.createObjectURL(blob);
  const link = document.createElement("a");
  link.href = downloadUrl;
  link.download = filename;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  window.URL.revokeObjectURL(downloadUrl);
}

export function listToMap(list, key = 'value', label = 'label') {
  return list.reduce((acc, item) => {
    acc[item[key]] = item[label];
    return acc;
  }, {});
}

// 处理时间参数
export function parseDateRange(range) {
  let begin_date = "";
  let end_date = "";

  if (range && Array.isArray(range) && range.length === 2) {
    const [startDate, endDate] = range;
    begin_date = startDate ? `${startDate} 00:00:00` : "";
    end_date = endDate ? `${endDate} 23:59:59` : "";
  }

  return { begin_date, end_date };
}

export function debounce(func, delay = 300) {
  let timer = null;
  return function (...args) {
    if (timer) clearTimeout(timer);
    timer = setTimeout(() => {
      func.apply(this, args);
    }, delay);
  };
}